import type { CandidateDeepDiveResponse } from '@/lib/contracts'

export const candidateDeepDiveIntro = {
  headline: 'AI Career Deep-Dive',
  bullets: [
    '15-minute conversation with Erica',
    'Explores motivations, preferences, and constraints',
    'Outputs a match-ready profile for recruiters',
  ],
}

export const candidateDeepDive: CandidateDeepDiveResponse = {
  conversation: [
    { id: 'turn-1', speaker: 'erica', text: 'Let’s start with energy — what types of roles excite you right now?', createdAt: '2026-03-16T18:10:00Z' },
    { id: 'turn-2', speaker: 'candidate', text: 'Operator roles where I can open new markets and scale teams.', createdAt: '2026-03-16T18:10:30Z' },
    { id: 'turn-3', speaker: 'erica', text: 'Any locations you want to prioritize or avoid?', createdAt: '2026-03-16T18:11:00Z' },
    { id: 'turn-4', speaker: 'candidate', text: 'Open to Riyadh or Dubai, need to stay within GMT+3.', createdAt: '2026-03-16T18:11:20Z' },
  ],
  summary: {
    candidateId: 'layla-haddad',
    targetRoles: ['GM Expansion', 'VP Sales – Emerging Markets'],
    locations: ['Riyadh', 'Dubai'],
    compensation: 'Base $250k + upside',
    mustHaves: ['Remote-first culture', 'Arabic-friendly clients', 'Series B–D stage'],
    niceToHaves: ['Existing infra in KSA', 'Greenfield expansion runway'],
  },
}
